"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function contains(arr, el) {
    return arr.indexOf(el) >= 0;
}
exports.contains = contains;
;

//# sourceMappingURL=Generic.js.map



//////////////////
// WEBPACK FOOTER
// ./~/xterm/lib/utils/Generic.js
// module id = 44
// module chunks = 0